import type { RevealStatus } from '../api/types';

interface Props {
  status: RevealStatus;
}

/**
 * Zeigt pro aktivem Spieler einen Pill-Badge: getippt (grün) oder
 * noch nicht (gedimmt). Spoilfrei — nur Namen + Status, keine
 * Differenzen oder Tipps.
 */
export function PlayerStatus({ status }: Props) {
  if (status.player_status.length === 0) return null;
  return (
    <div className="player-status">
      {status.player_status.map((p) => (
        <span
          key={p.player_id}
          className={`player-pill ${p.has_entry ? 'player-pill--done' : 'player-pill--waiting'}`}
        >
          <span className="player-pill__icon" aria-hidden="true">
            {p.has_entry ? '✓' : '·'}
          </span>
          {p.name}
        </span>
      ))}
    </div>
  );
}
